var _style, _g, _polygon, _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemorialGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 85",
    style: {
      enableBackground: "new 0 0 85 85"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CCCCCC;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:2.1073;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:1.9524;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.5,
    cy: 42.5,
    r: 42.5
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "42.4,25.4 44.3,29.2 48.6,29.9 45.5,32.9 46.2,37.2 42.4,35.1 38.5,37.2 39.3,32.9 36.2,29.9  40.5,29.2 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 42.4,
    cy: 32.3,
    r: 13.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 42.4,
    cy: 32.3,
    r: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.6,42.9c-0.2,0.8-8.1,21.5-7.6,21.5s7.1-5.7,7.1-5.1c0,0.5,2,8.7,2,8.7l4.8-22.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.8,43.3c0.1,0.8,6.2,23.3,5.7,23.2s-6.4-6.5-6.4-6S46,68.8,46,68.8l-3.5-23.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemorialGrey);
export default __webpack_public_path__ + "static/media/MemorialGrey.93eaf781341e6a404558c2cc08623f9d.svg";
export { ForwardRef as ReactComponent };